import React from 'react';
import ReactDOM from 'react-dom';
import '../index.css';
import App from '../components/App';
import { Helmet } from "react-helmet";


export default () => {
  return <><Helmet>
          <meta charSet="utf-8" />
          <title>MD Dashboard</title>
        </Helmet><p>Welcome to the MasterDocs Dashboard</p></>
};
